/* file description */
import React, { useMemo } from 'react';


export const useButtonProps = (btnInfo: Record<string, any>) => {
  return useMemo(() => {
    const options = {} as any;
    options.type = btnInfo.cate;
    if (btnInfo.cate === 'danger') {
      options.type = 'primary';
      options.danger = true;
    }
    return options;
  }, [btnInfo]);
};
